if (typeof window !== `undefined`) {
  window.addEventListener('scroll', () => {
    const isActive = () => {
      const container = document.querySelector('.scroll-container');
      return container && container.classList.contains('scrolling-active');
    };

    const currentY = window.scrollY;
    const threshhold = 5;
    const container = document.querySelector('.scroll-container');

    if (currentY <= threshhold && isActive() && container) {
      container.classList.remove('scrolling-active');
    } else if (currentY > threshhold && !isActive() && container) {
      container.classList.add('scrolling-active');
    }
  });
}
